import { render, staticRenderFns } from "./VirtualPackingSlipShipmentDetails.vue?vue&type=template&id=2542c9f0&scoped=true&"
import script from "./VirtualPackingSlipShipmentDetails.vue?vue&type=script&lang=js&"
export * from "./VirtualPackingSlipShipmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./VirtualPackingSlipShipmentDetails.vue?vue&type=style&index=0&id=2542c9f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2542c9f0",
  null
  
)

export default component.exports